import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSketch16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSketch16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="m8.028 3.002 3.295.372c.07.008.133.044.175.1l2.452 3.307a.25.25 0 0 1-.01.315l-5.844 6.86a.126.126 0 0 1-.192 0L2.06 7.096a.25.25 0 0 1-.01-.315l2.452-3.307a.25.25 0 0 1 .175-.1l3.295-.372a.3.3 0 0 1 .056 0m.684.713a.054.054 0 0 0-.084.065l.005.006 1.858 2.315a.126.126 0 0 1-.088.205H5.608a.126.126 0 0 1-.106-.195l.007-.01 1.858-2.315a.054.054 0 0 0-.073-.076l-.006.005L4.77 6.248a.101.101 0 0 1-.172-.066v-.01l.087-1.835a.05.05 0 0 0-.098-.02l-.002.007-.477 2.111a.2.2 0 0 1-.14.15l-.014.003-1.181.255a.05.05 0 0 0 .004.1H3.96c.069 0 .132.035.17.091l.007.012 2.826 5.045a.076.076 0 0 0 .137-.062l-.003-.007-2.284-4.863a.152.152 0 0 1 .126-.216h6.11a.152.152 0 0 1 .14.206l-.004.01-2.284 4.863a.076.076 0 0 0 .13.076l.004-.007 2.826-5.045a.2.2 0 0 1 .163-.103h1.192a.05.05 0 0 0 .017-.098l-.007-.002-1.18-.255a.2.2 0 0 1-.152-.14l-.003-.013-.477-2.111a.05.05 0 0 0-.1.006v.007l.087 1.835a.101.101 0 0 1-.165.083l-.008-.007z"
            />
        </svg>
    );
}
export default memo(IconSketch16);
